import {
  ADD_SYSTEM_NOTIFICATION,
  HIDE_MESSAGE,
  ON_SYSTEM_NOTIFICATION_CLOSED,
  SHOW_MESSAGE
} from 'constants/ActionTypes'

const initialSystemState = {
  message: undefined,
  notifications: []
}

const System = (state = initialSystemState, action) => {
  switch (action.type) {
    case ADD_SYSTEM_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.concat([ action.notification ])
      }

    case ON_SYSTEM_NOTIFICATION_CLOSED:
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.id !== action.notificationId)
      }

    case SHOW_MESSAGE: {
      return {
        ...state,
        message: action.message
      }
    }

    case HIDE_MESSAGE: {
      return {
        ...state,
        message: undefined
      }
    }

    default:
      return state
  }
}

export default System



// WEBPACK FOOTER //
// ./reducers/System.js